import { environment } from '../../environments/environment';

export const CMC_URL = environment.cmcUrl;
export const API_URL = environment.apiUrl;
export const CONSUMER_ACCESS_URL: string = 'https://www.nmlsconsumeraccess.org';
export const LEAVING_ARVEST_CMC: string = `You are about to visit a third-party site not operated by Arvest Central Mortgage Company.\n
Arvest Central Mortgage Company\'s privacy policy and security practices do not apply to the site you are about to enter, please review the third-party\'s privacy policy and security practices.`;

export const COUNTRIES = [
  { flag: "🇺🇸", code: "+1", name: "United States" },
  { flag: "🇨🇦", code: "+1", name: "Canada" },
  { flag: "🇲🇽", code: "+52", name: "Mexico" },
  { flag: "🇦🇺", code: "+61", name: "Australia" },
  { flag: "🇧🇷", code: "+55", name: "Brazil" },
  { flag: "🇨🇳", code: "+86", name: "China" },
  { flag: "🇨🇴", code: "+57", name: "Colombia" },
  { flag: "🇨🇷", code: "+506", name: "Costa Rica" }, 
  { flag: "🇫🇷", code: "+33", name: "France" },
  { flag: "🇩🇪", code: "+49", name: "Germany" },
  { flag: "🇭🇺", code: "+36", name: "Hungary" },
  { flag: "🇮🇳", code: "+91", name: "India" },
  { flag: "🇮🇪", code: "+353", name: "Ireland" },
  { flag: "🇲🇾", code: "+60", name: "Malaysia" },
  { flag: "🇵🇭", code: "+63", name: "The Philippines" }, 
  { flag: "🇵🇱", code: "+48", name: "Poland" },
  { flag: "🇷🇴", code: "+40", name: "Romania" },
  { flag: "🇪🇸", code: "+34", name: "Spain" },
  { flag: "🇬🇧", code: "+44", name: "United Kingdom" },
  { flag: "🇺🇸", code: "+1", name: "United States Minor Outlying Islands" },
  { flag: "🇻🇮", code: "+1340", name: "U. S. Virgin Islands" }
];